module.exports = __webpack_public_path__ + "static/media/gluten.63e0551b.png";